import TableCell from "@material-ui/core/TableCell";
import classNames from "classnames";
import Checkbox from "@material-ui/core/Checkbox";
import { TableRow } from "@material-ui/core";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { themeOptions } from "styles/theme";
import { IProductDataEntry } from "constants/product-customizations/customization";
import { CUSTOMIZATIONS } from "constants/integration/customizations";
import { BrandRecord } from "records/brand";
import { getImageSource } from "../helpers";

interface IProps {
    productDataEntry: IProductDataEntry;
    index: number;
    onRowClick: (event: React.MouseEvent<HTMLTableRowElement>, productDataEntry: IProductDataEntry) => void;
    selected: string[];
    brand: BrandRecord | null;
}

export const ProductListRow: React.FC<IProps> = ({ productDataEntry, index, onRowClick, selected, brand }) => {
    const classes = useStyles();

    const isSelected = (productId: string): boolean => selected.indexOf(productId) !== -1;
    const {
        product: { name, style_number, season, color, _id },
    } = productDataEntry;

    const image = getImageSource(brand, productDataEntry.product);

    const isItemSelected = isSelected(productDataEntry.lineItem?._id ?? _id);
    const labelId = `${CUSTOMIZATIONS.PRODUCT_LIST_ROW}-${index}`;

    return (
        <TableRow
            hover
            onClick={(event) => onRowClick(event, productDataEntry)}
            role="checkbox"
            tabIndex={-1}
            key={name}
            data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW}
        >
            <TableCell
                className={classNames(classes.tableCell, classes.checkboxCell)}
                padding="checkbox"
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                <Checkbox checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
            </TableCell>
            <TableCell
                className={classNames(classes.tableCell, classes.imageCell)}
                padding="checkbox"
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                {
                    <img
                        className={classes.productImage}
                        src={image}
                        role="presentation"
                        alt="product customization attribute image"
                    />
                }
            </TableCell>
            <TableCell
                className={classNames(classes.tableCell, classes.nameCell)}
                id={labelId}
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                {name}
            </TableCell>
            <TableCell
                className={classNames(classes.tableCell, classes.styleNumberCell)}
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                {style_number}
            </TableCell>
            <TableCell
                className={classNames(classes.tableCell, classes.seasonCell)}
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                {season}
            </TableCell>
            <TableCell
                className={classNames(classes.tableCell, classes.colorCell)}
                data-test={CUSTOMIZATIONS.PRODUCT_LIST_ROW_CELL}
            >
                {color}
            </TableCell>
        </TableRow>
    );
};

const useStyles = makeStyles({
    tableCell: {
        fontSize: "13px",
        "& .MuiCheckbox-colorSecondary.Mui-checked": {
            color: `${themeOptions.palette.primary1Color} !important`,
        },
    },
    checkboxCell: {
        maxWidth: "4%",
    },
    imageCell: {
        maxWidth: "8%",
    },
    nameCell: {
        maxWidth: "22%",
    },
    styleNumberCell: {
        maxWidth: "22%",
    },
    seasonCell: {
        maxWidth: "22%",
    },
    colorCell: {
        maxWidth: "22%",
    },
    productImage: {
        maxWidth: "100px",
        maxHeight: "70px",
    },
});
